import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Area } from '../../../DataStructures/Area/Area';
import { Trip } from '../../../DataStructures/Trip/Trip';
import { Week } from '../../../DataStructures/Week/Week';
import { MapControls } from '../../../utilities/MapControls/MapConrols';
import { MapWindowDialogComponent } from '../map-window-dialog/map-window-dialog.component';
import { TripSummaryComponent } from '../trip-summary/trip-summary.component';
declare var $: any;
@Component({
  selector: 'app-map-options-dialog',
  templateUrl: './marker-options-dialog.component.html',
  styleUrls: ['./marker-options-dialog.component.css']
})
export class MarkerOptionsDialogComponent implements OnInit, AfterViewInit {

  trip: Trip;
  areas: Array<Area> = [];
  controls: MapControls;
  ref: TripSummaryComponent;
  week: Week;
  persons: Array<string> = [];
  address;
  position;
  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<MapWindowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

    this.trip = data.trip;
    this.areas = data.areas;
    this.week = data.week;
    this.position = (this.trip.areas.indexOf(data.areas[0]) + 1);
    this.areas.forEach(a => {
      this.persons.push(a.destinations[0].person)
    });
    this.address = this.areas[0].address;
    this.controls = data.controls;
  }
  ngAfterViewInit(): void {
  }

  ngOnInit() {

  }

  swap() {
      this.controls.enableEditMode(this.trip, this.areas, "swap");
      this.dialogRef.close();
  }


  async update(newPos) {
    this.dialogRef.close({
      action: 'update',
      areas: this.areas,
      trip: this.trip,
      newPos:newPos
    });
  }

  moveToTrip() {
    this.controls.enableEditMode(this.trip, this.areas, "add");
    this.dialogRef.close();
  }

  createTrip() {
    this.dialogRef.close({
      action: 'new',
      areas: this.areas,
      trip: this.trip,
      newPos:null
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/optimizer/marker-options-dialog/marker-options-dialog.component.ts